"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initGlobalAnalyticEvents = initGlobalAnalyticEvents;
var _legacyEventNames = require("./legacyEventNames");
/**
 * @deprecated
 * Adds event listeners for the above mentioned custom events.
 * The handler transforms particular CustomEvent to AnalyticsEvent and re-triggers it in global
 * context, so that the analytics provider can finally catch it in one unified way.
 */

function initGlobalAnalyticEvents(handler) {
  _legacyEventNames.globalEventNames.forEach(eventName => window.addEventListener(eventName, event => handler(event.type, event.detail)));
}